import React, { useState, useEffect } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import Semester2Header from "./Semester2Header";
import SemesterCreate from "./SemesterCreate";

const Semester = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <Semester2Header />
          </PageHeader>

          <div className="main-content">
            <div className="row">
              <SemesterCreate />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Semester;
